import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LocationsManagementComponent } from 'src/app/components/main/shared/locations/locations-management/locations-management.component';

@Component({
  selector: 'app-all-locations-management',
  templateUrl: './all-locations-management.component.html',
  styleUrl: './all-locations-management.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LocationsManagementComponent],
})
export class AllLocationsManagementComponent {}
